(ns common.widgets.layout
  (:require ["@mui/material/Divider$default" :as Divider]
            [uix.core :as uix :refer [$ defui]]))

(defui stack-divider []
  ($ Divider {:sx #js {:borderWidth "1px"
                       :display "none"
                       "* + &" #js {:display "block"}
                       "&:last-child" #js {:display "none"}}}))
